import { useEffect, useState } from "react"

import { useLazyGetPerftestStatusesQuery } from "store/api/widgetsApi"

import { HalfDoughnutSummaryWidget } from "components/widgets/HalfDoughnutSummaryWidget"

const CHART_COLORS = {
  scheduled: "#6366F1",
  rescheduled: "#E0E7FF",
} as const

const dummyData = {
  scheduled: 14,
  rescheduled: 20,
}

const initialState = {
  scheduled: 0,
  rescheduled: 0,
}

interface WidgetScheduledProps {
  unsupported?: boolean
}

export const WidgetScheduled = ({ unsupported = false }: WidgetScheduledProps) => {
  const [triggerGetPerftestStatuses, { isFetching }] = useLazyGetPerftestStatusesQuery()
  const [widgetData, setWidgetData] = useState(initialState)

  useEffect(() => {
    if (unsupported) return

    const fetchData = async () => {
      const res = await triggerGetPerftestStatuses()
      if (res?.data?.data) {
        setWidgetData({
          scheduled: res.data.data.scheduled ?? 0,
          rescheduled: res.data.data.rescheduled ?? 0,
        })
      }
    }

    fetchData()
  }, [unsupported, triggerGetPerftestStatuses])

  const data = unsupported ? dummyData : widgetData

  return (
    <HalfDoughnutSummaryWidget
      title="Scheduled"
      chartOptions={{ cutout: "65%" }}
      isFetching={!unsupported && isFetching}
      items={[
        { label: "Scheduled", color: CHART_COLORS.scheduled, value: data.scheduled },
        { label: "Rescheduled", color: CHART_COLORS.rescheduled, value: data.rescheduled },
      ]}
    />
  )
}
